import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Highlight, HighlightType, HighlightVariant } from '@node-space/ui-components'
import { EarnDirectDetailsStatCard } from './EarnDirectDetailsStatCard'

export interface EarnDirectDetailsSummaryProps {
  earnRate: string
  allocatedFunds: string
  myLifetimeEarnings: string
  unallocatedFunds: string
  isStatisticsLoading?: boolean
}

export const EarnDirectDetailsSummary = ({
  earnRate,
  allocatedFunds,
  myLifetimeEarnings,
  unallocatedFunds,
  isStatisticsLoading,
}: EarnDirectDetailsSummaryProps) => {
  const { t } = useTranslation()

  return (
    <Box flexCol gap={16} className="lg:flex-row" testId="earn-details-summary-direct">
      <EarnDirectDetailsStatCard
        icon="CoinArrowInCustom"
        label={t('earn.yourAllocatedFunds')}
        value={allocatedFunds}
        highlight={
          <Highlight type={HighlightType.Feature} variant={HighlightVariant.Emphasis}>
            {t('earn.earningAtRate', { rate: earnRate })}
          </Highlight>
        }
      />
      <EarnDirectDetailsStatCard
        icon="SketchLogo"
        label={t('earn.myLifetimeEarnings')}
        value={myLifetimeEarnings}
      />
      <EarnDirectDetailsStatCard
        icon="HourglassMedium"
        label={t('earn.unallocatedFunds')}
        value={unallocatedFunds}
        isLoading={isStatisticsLoading}
        testId="earn-unallocated-funds"
      />
    </Box>
  )
}
